import { createCookie, readCookie } from '../Utility/CookieManager.js';

const WidgetsManager = () => import(/* webpackChunkName: "WidgetsManager" */ '../Widgets/WidgetsManager.js');
console.log('cool dst is loading');
function create_dst_ga_event(){
 
    if( typeof send_notifier_event == 'function' ){

      var on_dst_close_notifier_data = {
          'ge_action' : 'Called Tag',
          'ge_category' : 'Distroscale',
          'ge_label' : 'Page: home',
          'ge_index' : null,
          'ge_noninteraction' : true,
        };
  
      send_notifier_event(on_dst_close_notifier_data);
    }
  
}

function set_dst_close_listeners(){
  
    //COOKIE DISABLE THROTTLE WHEN USER CLICKS ON CLOSE BUTTON
    $(document).on('click', '#ds_float_close', function(){
      dst_close_event();
    });

    $(document).on('click', '#ds_close', function(){
      dst_close_event();
    });
}

function load_distro_when_ready_master(){
    if(browser_tab_is_visible == true){
        init_distro_master_set();
        return;
    }

    var distro_interval = setInterval(function() {

        // console.log("DISTRO BROWSER TAB VISIBLE?", browser_tab_is_visible);
        if(browser_tab_is_visible == false){
            return;
        }
        
        // console.log("DISTRO BROWSER IS VISIBLE SO CLEAR INTERVAL AND RUN IT", browser_tab_is_visible);
        clearInterval(distro_interval);
        init_distro_master_set();

    }, 1000);
}

function init_distro_master_set(){
    var distroscale = document.createElement('script');
    distroscale.type = 'text/javascript'; 
    distroscale.async = true;
    distroscale.src = (document.location.protocol == "https:" ? "https:" : "http:") + '//c.jsrdn.com/s/cs.js?p=22663';
    var dstrox = document.getElementsByTagName('script')[0];
    dstrox.parentNode.insertBefore(distroscale, dstrox); 
}

function init_distro_hp(){

    var launch_distro = false;
    
    if( SITE_INFO['name'] == "politics" && $("body.home").length > 0 ) { //HOMEPAGE ONLY

        if($().isTablet() === false){ //MOBILE OR NOT TABLET(TOUCH)
            launch_distro = true;
            create_dst_ga_event();
            set_dst_close_listeners();
        }
        $('.section-header.videos').css('margin-top', '-4px');
        $('#ds_default_anchor').css('height', '5px');
    // Launch on policy, science, defense homepages
    }else if(SITE_INFO['name']=="policy" && $("body.home").length>0) {

        $dstro = $('div.beta div.distro_spot');
        $dstro.append("<div id=\'ds_default_anchor\' class=\"ds_default_anchor\" style=\'margin-left:15px;\'></div>");
        launch_distro = true;

    }else if(SITE_INFO['name']=="defense" && $("body.home").length>0) {

        launch_distro = true;
    
    } else if(SITE_INFO['name']=="science" && $("body.home").length>0) {

        $dstro = $('div.beta div.distro_spot');
        $dstro.append("<div id=\'ds_default_anchor\' class=\"ds_default_anchor\" style=\'margin-left:15px;\'></div>");
        launch_distro = true;
    
    }

    /**
     * If ad free account or ad block then run recommended widget
     */
    if( launch_distro == true && ( parseInt(readCookie('evaf')) == 1 || Utils.global_settings.realclear_ad_block_check == true ) ){
        launch_distro = false;
        var rec_selector = 'div#dynamic-recommended';
        var recommended_id = 2;
        
        if ($(rec_selector).length == 0 && $('div[data-widget-title="Recommended"]').length == 0) {
            
            var widget_slot = '<div id="dynamic-recommended" class="widget_slot init dynamic" style="margin-bottom: 20px;" ></div>';
            $('div.beta').prepend(widget_slot);
            var widget_container = $(rec_selector);

            WidgetsManager()
            .then(module => {
                module.default(recommended_id, widget_container);
                widget_container.addClass('loaded');
            });
        }
        
        $('.ds_default_anchor').remove();
        // console.log('ad free account run recommended', launch_distro);
        return;
    }

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    console.log('should launch distro?', launch_distro);

    if(launch_distro) {
        // cookie shouldn't be made unless distro is actually launched
        load_distro_when_ready_master();
        createCookie("distroscale_shown_new", "1", 1, true); //hrs
    }
}
console.log('step 1 - line 190');
export default init_distro_hp;